import { heightChange } from "./heightChange";
import { addToSlip } from "./addToSlip";
import { HandlersRegistry } from "../common/types";
import { IframeEvents, MsgBusEvents } from "../common/events";
import { betSlipUpdate } from "./betSlipUpdate";
import { removeFromIframe } from "./removeFromIframe";
import { loaded } from "./loaded";
import { oddsFormatChange } from "./oddsFormatChange";
import { clearBetSlip } from "./clearBetSlip";
import { editSelection } from "./editSelection";

export const iframeHandlers: HandlersRegistry = {
  [IframeEvents.HEIGHT_CHANGE]: heightChange,
  [IframeEvents.ADD_TO_SLIP]: addToSlip,
  [IframeEvents.REMOVE_FROM_SLIP]: removeFromIframe,
  [IframeEvents.LOADED]: loaded,
  [IframeEvents.EDIT]: editSelection,
} as const;

export const msgBusHandlers: HandlersRegistry = {
  [MsgBusEvents.UPDATE_BETSLIP]: betSlipUpdate,
  [MsgBusEvents.ODDS_FORMAT_CHANGE]: oddsFormatChange,
  [MsgBusEvents.ODDS_FORMAT_CHANGE_MOBILE]: oddsFormatChange,
  [MsgBusEvents.CLEAR_SLIP]: clearBetSlip,
} as const;
